<template>
	<v-dialog
		v-model="dialogOpen"
		width="300"
		v-bind="$attrs"
	>
		<template
			v-for="(_, slot) of $slots"
			#[slot]="scope"
		>
			<slot
				:name="slot"
				v-bind="scope"
			/>
		</template>
		<v-card>
			<v-card-title>
				{{ $gettext(title) }}
			</v-card-title>
			<v-card-text>
				{{ $gettext(text) }}
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					variant="text"
					@click="dialogOpen = false"
				>
					<translate>
						No
					</translate>
				</v-btn>
				<v-btn
					color="primary"
					variant="text"
					@click="actionAndClose"
				>
					<translate>
						Yes
					</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'ConfirmDialog',
	props: {
		title: {
			type: String,
			default: 'Confirm Dialog'
		},
		text: {
			type: String,
			default: 'Are you sure?'
		},
	},
	emits: ['confirm',],
	data () {
		return {
			dialogOpen: false,
		};
	},
	methods: {
		/**
		 * run passed actions and then close dialog
		 */
		actionAndClose () {
			this.$emit('confirm');
			this.dialogOpen = false;
		}
	}
};
</script>

<style scoped>

</style>
